import React from "react";
import "./Service_pages.scss";
// FIX 1: Use the correct image name that exists in your folder
import img from "./services/root-canal.png"; 
import dentalImage from "./services/dental.png"; 

import { FaCheckCircle, FaTooth, FaUserMd, FaClinicMedical, FaMapMarkerAlt, FaMicroscope, FaStethoscope, FaSyringe, FaBroom, FaFillDrip, FaCrown } from 'react-icons/fa';
// FIX 2: Swapped MdEventRepeat for MdCached
import { MdOutlineHealthAndSafety, MdAccessTime, MdCached, MdHealing } from "react-icons/md";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const RootCanalTreatment = () => {

  const types = [
    {
      title: "Single-Visit Root Canal",
      icon: <MdAccessTime size={30} />,
      desc: "Advanced technology allows some cases, especially those with minimal infection, to be comfortably completed in just a single appointment.",
    },
    {
      title: "Multi-Visit Root Canal",
      // FIX 3: Changed icon variable name here
      icon: <MdCached size={30} />, 
      desc: "For severe infections or complex root structures, treatment may be completed over two or more visits to ensure complete healing and disinfection.",
    },
    {
      title: "Re-Root Canal Treatment",
      icon: <MdHealing size={30} />,
      desc: "If a previously treated tooth becomes infected again due to new decay or complex anatomy, retreatment can effectively save the tooth.",
    },
    {
      title: "Microscope-Assisted Root Canal",
      icon: <FaMicroscope size={30} />,
      desc: "Using high-powered dental microscopes improves precision, allowing us to find hidden canals and ensuring a higher success rate.",
    },
  ];

  const benefits = [
    {
      title: "Saves Your Natural Tooth",
      description: "RCT allows you to preserve your natural tooth instead of extracting it.",
    },
    {
      title: "Relieves Severe Pain",
      description: "The procedure eliminates the infected nerve, relieving tooth pain quickly.",
    },
    {
      title: "Prevents Infection Spread",
      description: "Removing infected pulp prevents bacteria from spreading to surrounding teeth and jawbone.",
    },
    {
      title: "Restores Normal Function",
      description: "After treatment, the tooth can function normally for chewing and speaking.",
    },
    {
      title: "Improves Oral Health",
      description: "Treating the infection prevents further dental and systemic health complications.",
    },
  ];

  const reasons = [
    {
      icon: <FaUserMd />,
      title: 'Experienced Endodontists',
      description: 'Our clinic has specialists highly trained in advanced endodontic procedures and restorative dentistry.'
    },
    {
      icon: <FaMicroscope />,
      title: 'Advanced Dental Technology',
      description: 'We use digital X-rays, CBCT imaging, and dental microscopes for precise diagnosis and treatment.'
    },
    {
      icon: <MdOutlineHealthAndSafety />,
      title: 'Pain-Free Dentistry',
      description: 'Modern anesthesia techniques ensure a comfortable, stress-free, and virtually painless experience.'
    },
    {
      icon: <FaClinicMedical />,
      title: 'Strict Sterilization Protocols',
      description: 'We maintain the highest global standards of hygiene and infection control for your safety.'
    },
    {
      icon: <FaTooth />,
      title: 'Personalized Treatment Plans',
      description: 'Every patient receives a customized treatment approach tailored specifically to their clinical needs.'
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Convenient Location',
      description: 'Easily accessible from HSR Layout, Koramangala, Sarjapur Road, and BTM Layout.'
    }
  ];

  const faqs = [
    { q: "Is root canal treatment painful?", a: "No. Modern techniques and local anesthesia make root canal treatment comfortable and pain-free." },
    { q: "How long does a root canal take?", a: "Most treatments take 60–90 minutes, depending on the complexity of the case." },
    { q: "Can I eat after a root canal?", a: "Yes, but it is recommended to avoid hard foods until the tooth is fully restored with a crown." },
    { q: "How long does a root canal treated tooth last?", a: "With proper care and a dental crown, the treated tooth can last for many years or even a lifetime." },
    { q: "Is a crown necessary after root canal treatment?", a: "Yes, especially for molars, because a crown protects the brittle treated tooth from fracturing." },
    { q: "What happens if I delay treatment?", a: "Delaying treatment allows the infection to spread, potentially leading to severe pain, abscess formation, or tooth loss." }
  ];

  return (
    <>
      <div className="service1-section">
        <Helmet>
          <title>Root Canal Treatment in HSR Layout | Pain-Free RCT at Kosmix</title>
          <meta
            name="description"
            content="Get advanced, pain-free root canal treatment in HSR Layout at Kosmix Dental Clinic. Save your natural tooth with our microscope-assisted endodontic specialists."
          />
          <link
            rel="canonical"
            href="https://www.kosmixdentalclinic.com/services/root-canal-treatment-in-hsr-layout"
          />
        </Helmet>

        <div className="hero">
          <h1 className="service1-title-text" data-aos="fade-down" data-aos-delay="200" style={{ fontFamily: 'initial' }}>
            Root Canal Treatment in HSR Layout
          </h1>

          <div className="hero-content">
            <div className="hero-image" data-aos="zoom-in-right" data-aos-delay="200" data-aos-duration="800">
              <img src={img} alt="Root Canal Treatment at Kosmix" />
            </div>

            <div className="hero-text" data-aos="zoom-in-left" data-aos-delay="200" data-aos-duration="800">
              <p>
                A Root Canal Treatment (RCT) is a highly effective dental procedure used to save a severely damaged or infected tooth. At Kosmix Dental Clinic in HSR Layout, we provide microscope-assisted, pain-free root canal treatments using advanced technology and modern dental techniques.
              </p>
              <p>
                Our experienced dental specialists ensure that every patient receives a precise diagnosis, comfortable treatment, and long-lasting results. Whether you are suffering from severe tooth pain, sensitivity, swelling, or infection, our expert team can help restore your tooth while preserving its natural structure.
              </p>
              <p>
                Root canal therapy not only eliminates infection but also prevents tooth extraction, helping maintain proper chewing function and protecting your natural, healthy smile.
              </p>
            </div>
          </div>
        </div>

      <div className="content text-center max-w-5xl mx-auto px-4" data-aos="fade-up" data-aos-delay="300">
  
  <SectionTitle title="What is Root Canal Treatment?" />

  <p className="mt-4 text-black leading-relaxed">
    Root Canal Treatment is a dental procedure used to remove infected or inflamed pulp tissue inside a tooth. 
    The pulp contains nerves and blood vessels that can become infected due to deep cavities, cracks, trauma, 
    or repeated dental procedures.
  </p>

  <h3 className="mt-10 text-2xl font-bold text-[#561b0f] text-center tracking-tight">
    During the Treatment:
  </h3>

  <div className="root-canal-treatment-focus mt-10">
    <div className="focus-item" data-aos="fade-up" data-aos-delay="100">
      <div className="focus-icon-circle"><FaMicroscope /></div>
      <div className="focus-text">The infected pulp is carefully removed.</div>
    </div>

    <div className="focus-item" data-aos="fade-up" data-aos-delay="200">
      <div className="focus-icon-circle"><FaBroom /></div>
      <div className="focus-text">The inner root canals are cleaned and disinfected.</div>
    </div>

    <div className="focus-item" data-aos="fade-up" data-aos-delay="300">
      <div className="focus-icon-circle"><FaFillDrip /></div>
      <div className="focus-text">The empty canals are filled and sealed securely.</div>
    </div>

    <div className="focus-item" data-aos="fade-up" data-aos-delay="400">
      <div className="focus-icon-circle"><FaCrown /></div>
      <div className="focus-text">A custom crown is usually placed on top to protect the tooth.</div>
    </div>
  </div>

  <p className="mt-6 text-black leading-relaxed">
    This procedure allows the tooth to function normally while preventing further infection.
  </p>

</div>
        <section className="importance-section">
          <div className="content">
            <h2 className="section-title" data-aos="fade-up">Signs You May Need a Root Canal</h2>
            <p1 className="text_first" data-aos="fade-up" data-aos-delay="100">
              If you notice any of these symptoms, it is important to consult our dentist immediately to prevent the infection from spreading:
            </p1>
          </div>

          <div className="importance-cards-container">
            {[
              { title: "Persistent or severe tooth pain", icon: <FaTooth /> },
              { title: "Prolonged sensitivity up to hot or cold", icon: <MdOutlineHealthAndSafety /> },
              { title: "Swelling or tenderness in the gums", icon: <MdHealing /> },
              { title: "Darkening or discoloration of a tooth", icon: <FaTooth /> },
              { title: "Pain while chewing or biting down", icon: <FaCheckCircle /> },
              { title: "A small pimple or abscess on the gum", icon: <FaClinicMedical /> },
              { title: "A cracked or broken tooth causing infection", icon: <FaCheckCircle /> },
            ].map((item, index) => (
              <div className="importance-card1" data-aos="fade-up" data-aos-delay={150 + index * 50} key={index}>
                <div className="card-icon">{item.icon}</div>
                <h4>{item.title}</h4>
              </div>
            ))}
          </div>
        </section>

        <section className="why-choose-us">
          <div className="wrapper">
            <div className="image-side" data-aos="zoom-in" data-aos-delay="100">
              <img src={dentalImage} alt="Causes of Tooth Infection" />
            </div>

            <div className="text-side" data-aos="fade-up" data-aos-delay="300">
              <h2>Common Causes of Tooth Infection</h2>
              <p style={{ color: 'black' }}>
                Tooth pulp infection doesn't happen overnight. It can occur due to several reasons, compromising the internal structure of your tooth:
              </p>

              <ul style={{ color: 'black', paddingLeft: '20px', lineHeight: '1.8' }}>
                <li><strong>Deep Tooth Decay:</strong> Untreated cavities can bypass the enamel and dentin, reaching the pulp to cause severe infection.</li>
                <li><strong>Cracked or Fractured Teeth:</strong> Trauma or biting hard foods may expose the pulp to oral bacteria.</li>
                <li><strong>Repeated Dental Procedures:</strong> Multiple restorations or drilling on the same tooth over time can irritate and inflame the pulp.</li>
                <li><strong>Injury or Trauma:</strong> Even if a tooth has no visible crack, a physical blow to the mouth can damage the pulp internally.</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="crown-types-section">
          <div className="content" data-aos="fade-up">
            <SectionTitle title="Types of Root Canal Treatments We Offer" />
          </div>

          <div className="crown-grid">
            {types.map((item, idx) => (
              <div className="crown-card" key={idx} data-aos="zoom-in" data-aos-delay={idx * 200}>
                <div className="icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="timeline-container">
          <div className="content" data-aos="fade-up">
            <SectionTitle title="Step-by-Step Root Canal Procedure" />
            <p className="text_first">
              At Kosmix Dental Clinic, we follow a precise and patient-friendly process to ensure successful treatment:
            </p>
          </div>

          <div className="timeline-step" data-aos="fade-right">
            <div className="timeline-icon"><FaStethoscope /></div>
            <div className="timeline-content">
              <h3>1. Dental Examination & Diagnosis</h3>
              <p>Our dentist performs a clinical examination along with digital X-rays or CBCT imaging to determine the exact extent of the infection.</p>
            </div>
            <div className="timeline-icon">1</div>
          </div>

          <div className="timeline-step" data-aos="fade-left">
            <div className="timeline-icon"><FaSyringe /></div>
            <div className="timeline-content">
              <h3>2. Local Anesthesia</h3>
              <p>The area around the affected tooth is numbed completely to ensure a pain-free and comfortable procedure.</p>
            </div>
            <div className="timeline-icon">2</div>
          </div>

          <div className="timeline-step" data-aos="fade-right">
            <div className="timeline-icon"><FaTooth /></div>
            <div className="timeline-content">
              <h3>3. Removal of Infected Pulp</h3>
              <p>A small access opening is created in the top of the tooth, and the infected or inflamed pulp tissue is carefully removed.</p>
            </div>
            <div className="timeline-icon">3</div>
          </div>

          <div className="timeline-step" data-aos="fade-left">
            <div className="timeline-icon"><FaBroom /></div>
            <div className="timeline-content">
              <h3>4. Cleaning and Disinfection</h3>
              <p>The root canals are thoroughly cleaned, shaped, and disinfected using advanced rotary instruments and antibacterial solutions.</p>
            </div>
            <div className="timeline-icon">4</div>
          </div>

          <div className="timeline-step" data-aos="fade-right">
            <div className="timeline-icon"><FaFillDrip /></div>
            <div className="timeline-content">
              <h3>5. Filling the Root Canal</h3>
              <p>The hollow canals are sealed using a rubber-like, biocompatible material (gutta-percha) to prevent any future reinfection.</p>
            </div>
            <div className="timeline-icon">5</div>
          </div>

          <div className="timeline-step" data-aos="fade-left">
            <div className="timeline-icon"><FaCrown /></div>
            <div className="timeline-content">
              <h3>6. Placement of Crown</h3>
              <p>A custom dental crown is recommended and placed over the treated tooth to restore its strength, shape, and aesthetic appearance.</p>
            </div>
            <div className="timeline-icon">6</div>
          </div>
        </section>

        <section className="advantages-section">
          <div className="content" data-aos="fade-up">
            <SectionTitle title="Benefits of Root Canal Treatment" />
          </div>

          <div className="advantages-grid">
            {benefits.map((item, index) => (
              <div key={index} className="advantage-card" data-aos="fade-up" data-aos-delay={index * 100}>
                <FaCheckCircle className="advantage-icon" />
                <div>
                  <h3>{item.title}</h3>
                  <p style={{fontSize: "14px", marginTop: "5px"}}>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="braces-pricing" data-aos="fade-up">
          <div className="braces-pricing__content">
            <div className="content" data-aos="fade-up">
              <SectionTitle title="Cost & Aftercare in Bengaluru" />
              <p1>
                The cost of RCT varies depending on tooth location, severity, and the type of crown required. We offer transparent pricing and affordable options. After your procedure, proper care ensures long-lasting results:
              </p1>
            </div>

            <div className="braces-pricing__cards" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '20px' }}>
              <div className="braces-card" style={{ width: '100%', maxWidth: '600px' }}>
                <div className="braces-card__tag">Post-Treatment Care</div>
                <h3 className="braces-card__price">Aftercare Tips</h3>
                <ul className="braces-card__details" style={{ textAlign: 'left', padding: '0 20px' }}>
                  <li>● Avoid chewing hard foods for a few days.</li>
                  <li>● Maintain oral hygiene by brushing and flossing regularly.</li>
                  <li>● Take prescribed medications as recommended by our dentist.</li>
                  <li>● Visit Kosmix Dental Clinic for follow-up appointments.</li>
                  <li>● <strong>Crucial:</strong> Get a crown placed promptly to protect the brittle tooth.</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="why-kosmix-timeline">
          <div className="content" data-aos="fade-up">
            <SectionTitle title="Why Choose Kosmix Dental Clinic for Root Canals?" />
            <p1 className="text_first">
              Patients across Bengaluru trust Kosmix{" "}
              <a href="https://www.kosmixdentalclinic.com" target="_blank" rel="noreferrer" className="inline-link">
                Dental Clinic in HSR
              </a> Layout for advanced, comfortable, and reliable dental care:
            </p1>
          </div>
          
          <div className="timeline">
            {reasons.map((reason, index) => (
              <div className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
                <div className="timeline-icon">{reason.icon}</div>
                <div className="timeline-content">
                  <h3>{reason.title}</h3>
                  <p style={{ display: window.innerWidth <= 768 ? 'none' : 'block' }}>
                    {reason.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FAQs Section */}
        <section className="content" data-aos="fade-up" style={{ maxWidth: '1000px', margin: '40px auto 80px' }}>
           <SectionTitle title="Frequently Asked Questions (FAQs)" />
           <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' }}>
             {faqs.map((faq, idx) => (
               <div key={idx} style={{ background: '#fdf6ec', padding: '20px 25px', borderRadius: '12px', borderLeft: '5px solid #561b0f', boxShadow: '0 4px 15px rgba(86, 27, 15, 0.05)' }}>
                 <h4 style={{ margin: '0 0 10px 0', color: '#561b0f', fontWeight: '700' }}>{faq.q}</h4>
                 <p style={{ margin: '0', color: '#3d2a1e', fontSize: '15px', lineHeight: '1.6' }}>{faq.a}</p>
               </div>
             ))}
           </div>
        </section>

        <section className="cta-section" data-aos='zoom-in'>
          <div className="cta-content">
            <h2>
              Schedule Your Appointment <span>Today!</span>
            </h2>
            <p>
              Experiencing tooth pain or sensitivity? Don't ignore the symptoms. Early treatment saves teeth. Visit Kosmix Dental Clinic for expert, pain-free root canal treatment.
            </p>
            <div className="cta-buttons">
              <Link to="/#appointment">
                <button className="btn-primary">Book Consultation</button>
              </Link>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

const SectionTitle = ({ title }) => (
  <h2 className="section-title">{title}</h2>
);

export default RootCanalTreatment;